import { PageBlockDefinition } from "@supernova-studio/model";
import * as Y from "yjs";
import { DTODocumentationHierarchyV2 } from "../../api";
import { DocumentationPageEditorModel } from "../docs-editor";
import { VersionRoomBaseYDoc } from "./base";
import { computeDocsHierarchy } from "./compute-dto";
import { generatePageContentHash } from "./utils";

export class FrontendVersionRoomYDoc {
  private readonly yDoc: Y.Doc;

  constructor(yDoc: Y.Doc, private readonly debug = false) {
    this.yDoc = yDoc;
  }

  //
  // Hierarchy
  //

  getDocumentationHierarchy(
    options: { includeDeletedContent?: boolean; debug?: boolean } = {}
  ): DTODocumentationHierarchyV2 {
    const doc = new VersionRoomBaseYDoc(this.yDoc);
    return computeDocsHierarchy(doc.getState(), options);
  }

  //
  // Update page content hash
  //

  notifyDocumentationPageContentUpdated(
    pageId: string,
    content: DocumentationPageEditorModel,
    definitions: PageBlockDefinition[]
  ) {
    const pageContentHash = generatePageContentHash(content, definitions, this.debug);
    if (this.debug) {
      console.log(`Will set page content hash: '${pageId}' : '${pageContentHash}'`);
    }

    new VersionRoomBaseYDoc(this.yDoc).updateDocumentationPageContentHashes({
      [pageId]: pageContentHash,
    });
  }

  //
  // Misc
  //

  isDraftFeatureAdopted() {
    const doc = new VersionRoomBaseYDoc(this.yDoc);
    const settings = doc.getDocumentationInternalSettings();
    return settings.isDraftFeatureAdopted;
  }

  hasPublishedDocumentationContent() {
    const doc = new VersionRoomBaseYDoc(this.yDoc);

    return (
      doc.getPageSnapshots().filter(s => s.reason === "Publish").length > 0 ||
      doc.getGroupSnapshots().filter(s => s.reason === "Publish").length > 0
    );
  }

  isApprovalsFeatureEnabled() {
    const doc = new VersionRoomBaseYDoc(this.yDoc);
    const settings = doc.getDocumentationInternalSettings();
    return settings.isApprovalFeatureEnabled;
  }

  isApprovalRequiredForPublishing() {
    const doc = new VersionRoomBaseYDoc(this.yDoc);
    const settings = doc.getDocumentationInternalSettings();
    return settings.approvalRequiredForPublishing;
  }
}
